exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/modules/_wks-ext.js
// module id = 309
// module chunks = 0